import React from 'react';
import SearchComponent from '../../components/searchComponent';
import { connect } from "react-redux";
import { SearchAction, SearchResult } from '../../store/actions/searchAction';
import history from '../../utils/history';
import Axios from "axios";
import { VERIFY_SESSION_PATH } from '../../config/path';
class Search extends React.Component {
    static displayName = 'Search';

    handleSearch = (data) => {
        this.props.handleSearch(data);
    }
    showDocDetails = (docName) => {
        this.props.showDocDetails(docName);
    }
    async componentDidMount() {
        try {
            const authCheck = await Axios.get(VERIFY_SESSION_PATH);
            if (!authCheck.data.authenticated) {
                history.push("/");
            }
        } catch (error) {
            console.error("Authentication check failed:", error);
            history.push("/");
        }
    }
    render() {
        return (
            <div>
                <SearchComponent
                    handleSearch={this.handleSearch}
                    searchList={this.props.searchReducer.SearchList}
                    showDocDetails={this.props.showDocDetails}
                    data={this.props.data}
                    delete={this.props.delete} 
                    keyval={this.props.keyval}
                />
            </div>
        )
    }
}
export function mapDispatchToProps(dispatch) {
    // eslint-disable-line
    return {
        handleSearch: data => { dispatch(SearchAction(data)) },
        showDocDetails: data => { dispatch(SearchResult(data)) }

    };
}

function mapStateToProps(state) {
    return state;
}

export default connect(
    mapStateToProps,
    mapDispatchToProps)(Search);
